
<script>
// ここでこのコンポーネントで使用するグラフの種類を定義する。
import { Doughnut } from 'vue-chartjs'

export default ({
	extends: Doughnut,
	props:[
		'levelScorePercentageArray',
		'levelColor',
	],
	data() {
		return {

			datas: {
				// 凡例とツールチップに表示するラベル
				labels: ['内向度',],
				// 表示するデータ
				datasets: [
					{
						data: this.levelScorePercentageArray,
						backgroundColor: this.levelColor,
						borderColor: 'transparent'
					}
				]
			},
			options: {
				cutoutPercentage:90,
				responsive: true,
				legend :{
					display: false,
				},
				tooltips:{
					enabled: false,
				},
				title: {
					display: false,
				}
			}
		}
	},
	mounted() {
		this.renderChart(this.datas, this.options)
	},

	computed: {

  },	
})
</script>